module.exports = __webpack_public_path__ + "static/media/captions_Shaw Pen.2ac07026.vtt";


//////////////////
// WEBPACK FOOTER
// ./src/subtitles/captions_Shaw Pen.vtt
// module id = 124
// module chunks = 0